import { Fade, SxProps, Theme, TooltipProps } from '@mui/material';

export const TabNamePaddingY = 12;

export const TabNameTooltipEnterDelay = 300;

export const TabNameTooltipOffsetY = 5;

export const TabNameStyles: SxProps<Theme> = {
  fontSize: 14,
  fontWeight: 500,
  lineHeight: '17px',
  padding: `${TabNamePaddingY}px 0`,
  marginLeft: '4px',
  textTransform: 'none',
  color: 'customColors.blue.950',
  maxWidth: 150,
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
};

export const TabNameTooltipSlots: TooltipProps['slots'] = {
  transition: Fade,
};

export const TabNameTooltipStyles: TooltipProps['slotProps'] = {
  tooltip: {
    sx: {
      backgroundColor: 'customColors.gray.900',
      fontSize: 13,
    },
  },
};
